export enum Sibling {
  Brother = 1,
  Sister = 2,
}
